(() => {
  const lade = document.querySelector('[data-lade]');
  if (!lade) return;

  const d = lade.dataset;
  const ZAKELIJK = d.zakelijk === 'true';
  const FACTOR = ZAKELIJK && d.factor ? Number(d.factor) / 100000 : 1;
  const NODIG = Number(d.actieNodig) || 0;
  const ACTIE_PCT = d.actiePct || '';
  const VRIJ_VANAF = Number(d.vrijVanaf) || 15000;
  const BIJNA = VRIJ_VANAF / 5;
  const VERZ_KOSTEN = d.verzKosten !== undefined && d.verzKosten !== '' ? Number(d.verzKosten) : null;
  const set = (s) => new Set((s || '').split(',').filter(Boolean));
  const MEE = set(d.mee);
  const PAAL = set(d.paal);
  const CADEAU_KABEL = Number(d.cadeauKabel) || 0;
  const CADEAU_LADER = Number(d.cadeauLader) || 0;
  const KABELS = set(d.kabels);
  const LADERS = set(d.laders);
  const CADEAU_TOT = d.cadeauEind ? new Date(`${d.cadeauEind}T23:59:59`).getTime() : 0;
  const ACC = set(d.acc);
  const HOUDER = Number(d.houder) || 0;
  const TAS = Number(d.tas) || 0;
  const ACC_PCT = Number(d.accPct) || 0;
  const KEUZE = { kabel: 'vt-cadeau-kabel', lader: 'vt-cadeau-lader' };
  function cadeauVoor(soort, standaard) {
    let v = 0;
    try { v = Number(localStorage.getItem(KEUZE[soort])) || 0; } catch {  }
    if (!v || (v !== HOUDER && v !== TAS)) return standaard;
    const p = ACCESSOIRES.find((a) => a.variant === v);
    return p && !p.beschikbaar ? standaard : v;
  }
  const TREDEN = (() => {
    try {
      return JSON.parse(d.staffel || '[]')
        .map((t) => ({ vanaf: Number(t.vanaf), procent: Number(t.procent) }))
        .filter((t) => t.vanaf > 0 && t.procent > 0)
        .sort((a, b) => a.vanaf - b.vanaf);
    } catch {
      return [];
    }
  })();
  const T = (() => {
    try {
      return JSON.parse(lade.querySelector('[data-lade-tekst]').textContent);
    } catch {
      return {};
    }
  })();
  const tekst = (sleutel, waarden = {}) =>
    Object.entries(waarden).reduce((t, [k, v]) => t.split(`[${k}]`).join(v), T[sleutel] || '');

  const el = (naam) => lade.querySelector(`[data-lade-${naam}]`);
  const icoon = (naam) =>
    lade.querySelector(`[data-lade-iconen]`)?.content.querySelector(`[data-icoon="${naam}"]`)?.innerHTML || '';

  const veilig = (t) =>
    String(t ?? '').replace(/[&<>"']/g, (c) =>
      ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])
    );

  let wagen = null;

  const geld = (centen) => window.vtGeld(Math.round((centen || 0) * FACTOR));
  const procent = (pct) => new Intl.NumberFormat(document.documentElement.lang || 'nl', { maximumFractionDigits: 1 }).format(pct);

  const open = () => window.VtDialoog.open(lade);
  const sluit = () => window.VtDialoog.sluit(lade);

  lade.addEventListener('close', stopOk);
  el('sluit')?.addEventListener('click', sluit);

  const ROOT = window.Shopify?.routes?.root || '/';
  const pad = (p) => ROOT + p;

  async function haal() {
    const r = await fetch(pad('cart.js'), { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('wagen niet gelezen');
    wagen = await r.json();
    return wagen;
  }

  async function lees() {
    await haal();
    for (let ronde = 0; ronde < 3; ronde += 1) {
      if (!(await cadeauGoed())) break;
      await haal();
    }
    return wagen;
  }

  async function post(pad, body) {
    const r = await fetch(pad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!r.ok) {
      const fout = new Error(pad + ' mislukt');
      fout.status = r.status;
      try { fout.uitleg = (await r.json()).description || ''; } catch { fout.uitleg = ''; }
      throw fout;
    }
    return r.json();
  }

  const isPaal = (i) => PAAL.has(String(i.product_id));
  const isAcc = (i) => ACC.has(String(i.product_id));
  const isCadeau = (i) => Boolean(i.properties?._cadeau) && isAcc(i);
  const doetMee = (i) => MEE.has(String(i.product_id));

  let cadeauMislukt = false;
  let cadeauGemeld = false;

  const stuksVan = (items) => items.reduce((n, i) => n + i.quantity, 0);
  const cadeauLoopt = () => Boolean(CADEAU_KABEL || CADEAU_LADER) && Date.now() <= CADEAU_TOT;

  function cadeauStand() {
    const items = wagen?.items || [];
    const kabels = cadeauLoopt() ? stuksVan(items.filter((i) => !isAcc(i) && KABELS.has(String(i.product_id)))) : 0;
    const laders = cadeauLoopt() ? stuksVan(items.filter((i) => !isAcc(i) && LADERS.has(String(i.product_id)))) : 0;
    const cadeaus = items.filter(isCadeau);
    const eigen = stuksVan(items.filter((i) => isAcc(i) && !isCadeau(i)));
    const plekken = kabels + laders;
    return { kabels, laders, plekken, cadeaus, gemerkt: stuksVan(cadeaus), eigen, vrij: Math.max(0, plekken - eigen) };
  }

  const neeBij = () => Number(wagen?.attributes?._cadeau_nee) || 0;

  async function cadeauGoed() {
    const s = cadeauStand();

    if (neeBij() > s.plekken) {
      await post(pad('cart/update.js'), { attributes: { _cadeau_nee: s.plekken ? String(s.plekken) : '' } });
      return true;
    }

    if (s.gemerkt > s.plekken) {
      let weg = s.gemerkt - s.plekken;
      const updates = {};
      for (const r of [...s.cadeaus].reverse()) {
        if (!weg) break;
        const min = Math.min(weg, r.quantity);
        updates[r.key] = r.quantity - min;
        weg -= min;
      }
      await post(pad('cart/update.js'), { updates });
      return true;
    }

    const doel = Math.max(0, s.vrij - Math.min(neeBij(), s.plekken));
    if (s.gemerkt < doel && !cadeauMislukt) {
      const kabelCadeau = cadeauVoor('kabel', CADEAU_KABEL);
      const laderCadeau = cadeauVoor('lader', CADEAU_LADER);
      const van = (v) => stuksVan((wagen?.items || []).filter((i) => isAcc(i) && i.variant_id === v));
      let nodig = doel - s.gemerkt;
      const voorKabel = Math.min(nodig, Math.max(0, s.kabels - van(kabelCadeau)));
      nodig -= voorKabel;
      const alVoorLader = laderCadeau === kabelCadeau ? Math.max(0, van(laderCadeau) - s.kabels) : van(laderCadeau);
      const voorLader = Math.min(nodig, Math.max(0, s.laders - alVoorLader));
      nodig -= voorLader;
      const regels = [];
      const erbij = (id, n) => {
        if (!id || n <= 0) return;
        const al = regels.find((r) => r.id === id);
        if (al) al.quantity += n;
        else regels.push({ id, quantity: n, properties: { _cadeau: 'ja' } });
      };
      erbij(kabelCadeau, voorKabel);
      erbij(laderCadeau, voorLader);
      erbij(s.kabels >= s.laders ? kabelCadeau || laderCadeau : laderCadeau || kabelCadeau, nodig);
      if (!regels.length) return false;
      try {
        await post(pad('cart/add.js'), { items: regels });
        return true;
      } catch {
        cadeauMislukt = true;
        return false;
      }
    }
    return false;
  }

  function groepen() {
    const uit = new Map();
    (wagen?.items || []).forEach((i) => {
      const zichtbaar = Object.entries(i.properties || {})
        .filter(([k, v]) => !k.startsWith('_') && v !== '' && v != null)
        .map(([k, v]) => `${k}=${v}`)
        .join('|');
      const sleutel = `${i.variant_id}|${zichtbaar}${isCadeau(i) ? '|cadeau' : ''}`;
      const g = uit.get(sleutel) || { sleutel, regels: [], aantal: 0, nu: 0, was: 0, labels: new Set(), eerste: i };
      g.regels.push(i);
      g.aantal += i.quantity;
      g.nu += i.final_line_price;
      g.was += i.original_line_price;
      (i.line_level_discount_allocations || []).forEach((a) => {
        const titel = a.discount_application?.title;
        if (titel) g.labels.add(titel);
      });
      uit.set(sleutel, g);
    });
    return [...uit.values()];
  }

  function icoonVoor(i) {
    const h = `${i.handle || ''} ${i.product_title || ''}`.toLowerCase();
    if (isPaal(i)) return 'charger';
    if (h.includes('goot')) return 'goot';
    if (h.includes('houder')) return 'houder';
    if (h.includes('tas')) return 'tas';
    if (h.includes('adapter') || h.includes('verloopstekker')) return 'plug';
    return 'cable';
  }

  const klein = (url) => {
    if (!url) return '';
    try {
      const u = new URL(url, location.origin);
      u.searchParams.set('width', '160');
      return u.toString();
    } catch {
      return url;
    }
  };

  const beste = (g) => (g.regels.find((r) => r.properties && r.properties._laadcheck)?.properties._laadcheck) || '';

  function zetRegels() {
    const vak = el('regels');
    const gs = groepen().sort((a, b) => isCadeau(a.eerste) - isCadeau(b.eerste));

    vak.innerHTML = gs
      .map((g) => {
        const i = g.eerste;
        const naam = veilig(i.product_title);
        const meta = i.variant_title ? veilig(i.variant_title) : '';
        const korting = g.nu < g.was;
        const cadeau = isCadeau(i);
        const labels = [...g.labels].map((l) => `<span class="vt-lade__label">${veilig(l)}</span>`).join('');
        const foto = i.image
          ? `<img src="${veilig(klein(i.image))}" alt="" width="72" height="72" loading="lazy">`
          : icoon(icoonVoor(i));

        return `
          <div class="vt-lade__regel">
            <div class="vt-lade__rij">
              <a class="vt-lade__foto" href="${veilig(i.url)}" tabindex="-1" aria-hidden="true">${foto}</a>
              <div>
                <a class="vt-lade__naam" href="${veilig(i.url)}">${naam}</a>
                ${meta ? `<p class="vt-lade__meta">${meta}</p>` : ''}
                ${beste(g) ? `<p class="vt-lade__beste">${icoon('check')}<span>${veilig(tekst('beste', { naam: beste(g) }))}</span></p>` : ''}
                ${cadeau ? '' : labels}
                ${cadeau ? `<p class="vt-lade__cadeau">${g.aantal > 1 ? `${g.aantal}× ` : ''}${veilig(tekst('cadeau_regel'))}</p>
                ${ruilNaar(i) ? `<div class="vt-lade__ond vt-lade__ond--cadeau">
                  <button type="button" class="vt-lade__weg" data-lade-ruil="${veilig(g.sleutel)}">${veilig(tekst('cadeau_ruil', { naam: ruilNaar(i).naam }))}</button>
                </div>` : ''}` : `<div class="vt-lade__ond">
                  <div class="vt-lade__stap">
                    <button type="button" data-lade-min="${veilig(g.sleutel)}" aria-label="${veilig(tekst('min', { naam: i.product_title }))}">${icoon('minus')}</button>
                    <output aria-live="polite">${g.aantal}</output>
                    <button type="button" data-lade-plus="${veilig(g.sleutel)}" aria-label="${veilig(tekst('plus', { naam: i.product_title }))}">${icoon('plus')}</button>
                  </div>
                  <button type="button" class="vt-lade__weg" data-lade-weg="${veilig(g.sleutel)}">${veilig(tekst('verwijderen'))}</button>
                </div>`}
              </div>
              <div class="vt-lade__rechts">
                <p class="vt-lade__prijs${cadeau && !g.nu ? ' is-gratis' : korting ? ' is-korting' : ''}">
                  ${cadeau && !g.nu ? `<s>${geld(g.was)}</s><b>${veilig(tekst('cadeau_prijs'))}</b>` : korting ? `<s>${geld(g.was)}</s><b>${geld(g.nu)}</b>` : geld(g.nu)}
                </p>
                ${cadeau ? `<button type="button" class="vt-lade__kruis" data-lade-weg="${veilig(g.sleutel)}" aria-label="${veilig(`${tekst('verwijderen')}: ${i.product_title}`)}">${icoon('close')}</button>` : ''}
              </div>
            </div>
          </div>`;
      })
      .join('')
      + (cadeauGeweigerd()
        ? `<button type="button" class="vt-lade__weg vt-lade__terug" data-lade-cadeau-terug>${veilig(tekst('cadeau_terug'))}</button>`
        : '');
  }

  const cadeauGeweigerd = () => {
    const s = cadeauStand();
    return neeBij() > 0 && s.gemerkt < s.vrij;
  };

  function ruilNaar(i) {
    const naar = i.variant_id === HOUDER ? TAS : i.variant_id === TAS ? HOUDER : 0;
    if (!naar) return null;
    const ander = ACCESSOIRES.find((p) => p.variant === naar);
    return ander?.beschikbaar ? { id: naar, naam: tekst(naar === HOUDER ? 'kort_houder' : 'kort_tas') } : null;
  }

  const actieStuks = () =>
    (wagen?.items || []).filter((i) => doetMee(i) && !isCadeau(i)).reduce((n, i) => n + i.quantity, 0);

  function zetSet() {
    const vak = el('set');
    if (!vak) return;
    const items = wagen?.items || [];
    const stuks = actieStuks();
    const alleenPaal = !stuks && items.some((i) => isPaal(i) && !isCadeau(i));
    if (ZAKELIJK || !NODIG || (!stuks && !alleenPaal)) {
      vak.hidden = true;
      return;
    }
    const balk = el('actie-balk');
    balk.parentElement.hidden = alleenPaal;
    vak.hidden = false;
    if (alleenPaal) {
      el('actie').classList.remove('is-gehaald');
      el('actie-kop').textContent = tekst('paal_erbij');
      vulVoorstel(items);
      return;
    }
    const nog = Math.max(0, NODIG - stuks);
    if (nog > 1) {
      vak.hidden = true;
      return;
    }
    el('actie').classList.toggle('is-gehaald', nog === 0);
    el('actie-kop').textContent = nog === 0
      ? tekst('actie_klaar', { pct: ACTIE_PCT, n: stuks })
      : tekst('actie_nog_1', { pct: ACTIE_PCT });
    balk.style.width = Math.min(100, Math.round((stuks / NODIG) * 100)) + '%';
    el('actie-lijst').hidden = true;
  }

  const RESERVE = (() => {
    try { return JSON.parse(lade.querySelector('[data-lade-reserve]')?.textContent || '[]'); } catch { return []; }
  })();
  const ACCESSOIRES = (() => {
    try { return JSON.parse(lade.querySelector('[data-lade-accessoires]')?.textContent || '[]'); } catch { return []; }
  })();
  const AANBEVOLEN = d.aanbevolen || '';
  const VOORKEUR_PAAL = ['kabel', 'acc'];
  const FAMILIE = new Map(RESERVE.filter((p) => p.familie).map((p) => [String(p.id), p.familie]));
  const hoortErbij = new Map();
  let voorstelBeurt = 0;

  async function erbijVoor(productId) {
    if (hoortErbij.has(productId)) return hoortErbij.get(productId);
    let lijst = [];
    if (AANBEVOLEN) {
      try {
        const r = await fetch(`${AANBEVOLEN}.json?product_id=${productId}&limit=6&intent=complementary`, { headers: { Accept: 'application/json' } });
        if (r.ok) {
          lijst = ((await r.json()).products || []).map((p) => ({
            id: p.id,
            titel: p.title,
            url: p.url,
            beschikbaar: p.available,
            variant: (p.variants || []).find((v) => v.available)?.id || p.variants?.[0]?.id,
            enkel: (p.variants || []).length === 1,
            prijs: p.price_min ?? p.price,
            beeld: p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=120` : '',
          }));
        }
      } catch {  }
    }
    hoortErbij.set(productId, lijst);
    return lijst;
  }

  async function vulVoorstel(items) {
    const lijst = el('actie-lijst');
    if (!lijst) return;
    const beurt = ++voorstelBeurt;
    const inWagen = new Set(items.map((i) => String(i.product_id)));
    const ankerItems = items.filter((i) => !isCadeau(i) && isPaal(i));
    const ankers = [...new Set(ankerItems.map((i) => i.product_id))];
    const gevonden = [];
    for (const id of ankers) gevonden.push(...(await erbijVoor(id)));
    if (beurt !== voorstelBeurt) return;

    const reserve = VOORKEUR_PAAL.flatMap((soort) => RESERVE.filter((p) => p.soort === soort));
    const gezien = new Set();
    const famGezien = new Set(items.map((i) => FAMILIE.get(String(i.product_id))).filter(Boolean));
    const keuze = [...gevonden, ...reserve].filter((p) => {
      const id = String(p.id);
      if (gezien.has(id) || inWagen.has(id) || !p.beschikbaar || !MEE.has(id)) return false;
      const fam = FAMILIE.get(id);
      if (fam && famGezien.has(fam)) return false;
      gezien.add(id);
      if (fam) famGezien.add(fam);
      return true;
    }).slice(0, 3);

    lijst.innerHTML = keuze.map((p) => {
      const naam = veilig(p.titel);
      const foto = p.beeld
        ? `<img src="${veilig(p.beeld)}" width="48" height="48" loading="lazy" alt="">`
        : icoon('cable');
      const prijs = p.enkel ? geld(p.prijs) : `${veilig(tekst('vanaf'))} ${geld(p.prijs)}`;
      const actie = p.enkel
        ? `<button type="button" class="vt-lade__plusrond" data-lade-voeg="${p.variant}" aria-label="${veilig(tekst('voeg_toe', { naam: p.titel }))}">${icoon('plus')}</button>`
        : `<a class="vt-lade__plusrond" href="${veilig(p.url)}" aria-label="${veilig(tekst('kies', { naam: p.titel }))}">${icoon('arrow')}</a>`;
      return `<li class="vt-lade__acc" data-lade-acc="${p.variant}">
        <span class="vt-lade__foto vt-lade__foto--klein">${foto}</span>
        <span class="vt-lade__acctekst"><a href="${veilig(p.url)}">${naam}</a><span class="vt-lade__accprijs">${prijs}</span></span>
        ${actie}</li>`;
    }).join('');
    lijst.hidden = keuze.length === 0;
    el('set').hidden = keuze.length === 0;
  }

  function zetAcc() {
    const vak = el('acc10');
    if (!vak) return;
    const items = wagen?.items || [];
    const naastAankoop = items.some((i) => doetMee(i) && !isCadeau(i));
    const inWagen = new Set(items.map((i) => String(i.product_id)));
    const keuze = naastAankoop && ACC_PCT && !ZAKELIJK
      ? ACCESSOIRES.filter((p) => p.beschikbaar && !inWagen.has(String(p.id)))
      : [];
    vak.hidden = keuze.length === 0;
    el('acc10-lijst').innerHTML = keuze.map((p) => {
      const naam = veilig(p.titel);
      const foto = p.beeld ? `<img src="${veilig(p.beeld)}" width="48" height="48" loading="lazy" alt="">` : icoon('houder');
      const nu = p.prijs - Math.floor((p.prijs * ACC_PCT) / 100);
      return `<li class="vt-lade__acc" data-lade-acc="${p.variant}">
        <span class="vt-lade__foto vt-lade__foto--klein">${foto}</span>
        <span class="vt-lade__acctekst"><a href="${veilig(p.url)}">${naam}</a><span class="vt-lade__accprijs"><s>${geld(p.prijs)}</s> <b>${geld(nu)}</b> <span class="vt-lade__label">${veilig(tekst('acc_label'))}</span></span></span>
        <button type="button" class="vt-lade__plusrond" data-lade-voeg="${p.variant}" aria-label="${veilig(tekst('voeg_toe', { naam: p.titel }))}">${icoon('plus')}</button></li>`;
    }).join('');
  }

  function zetStaffel() {
    const vak = el('staffel');
    if (!vak || !ZAKELIJK || !TREDEN.length) return;
    const mee = groepen().filter((g) => doetMee(g.eerste));
    vak.hidden = mee.length === 0;
    if (!mee.length) return;
    const aantal = mee.reduce((n, g) => n + g.aantal, 0);
    const g = mee.reduce((a, b) => (b.aantal > a.aantal ? b : a));
    const nu = [...TREDEN].reverse().find((t) => aantal >= t.vanaf) || null;
    const volgende = TREDEN.find((t) => aantal < t.vanaf) || null;
    el('staffel-kop').textContent = nu ? tekst('staffel_actief', { pct: procent(nu.procent) }) : tekst('staffel_bereik');
    el('staffel-sub').textContent = volgende
      ? tekst('staffel_nog', { n: volgende.vanaf - aantal, pct: procent(volgende.procent) })
      : tekst('staffel_top');
    const knop = el('staffel-knop');
    knop.hidden = !volgende;
    if (volgende) {
      knop.textContent = '+' + (volgende.vanaf - aantal);
      knop.dataset.sleutel = g.sleutel;
      knop.dataset.aantal = String(volgende.vanaf - aantal);
    }
    el('staffel-balk').style.width =
      Math.min(100, Math.round((aantal / (volgende ? volgende.vanaf : aantal)) * 100)) + '%';
  }

  const gekocht = () => (wagen?.items || []).filter((i) => !isCadeau(i)).reduce((n, i) => n + i.quantity, 0);

  function zetVoet() {
    const leeg = !wagen?.item_count;
    el('voet').hidden = leeg;
    el('leeg').hidden = !leeg;
    el('aantal').textContent = leeg ? '' : ` (${gekocht()})`;
    const offerte = el('offerte');
    if (offerte) {
      const paal = (wagen?.items || []).find(isPaal);
      offerte.hidden = !paal;
      if (paal) {
        const doel = new URL(offerte.getAttribute('href'), location.origin);
        doel.searchParams.set('paal', paal.handle);
        doel.searchParams.set('variant', paal.variant_id);
        offerte.setAttribute('href', doel.pathname + doel.search);
      }
    }
    if (leeg) return;

    const tot = wagen.total_price;
    const gehaald = tot >= VRIJ_VANAF;
    const bijna = !gehaald && VRIJ_VANAF - tot <= BIJNA;
    el('verz').hidden = !bijna;
    if (bijna) {
      el('verz-tekst').innerHTML = veilig(tekst('nog_tot_gratis', { bedrag: '\u0000' }))
        .replace('\u0000', `<b>${geld(VRIJ_VANAF - tot)}</b>`);
      el('verz-balk').style.width = Math.min(100, (tot / VRIJ_VANAF) * 100) + '%';
    }
    el('verz-rij').hidden = bijna;
    const kosten = gehaald || VERZ_KOSTEN === null ? 0 : VERZ_KOSTEN;
    el('verz-waarde').textContent = gehaald || VERZ_KOSTEN === 0
      ? tekst('verz_gratis')
      : VERZ_KOSTEN !== null ? geld(VERZ_KOSTEN) : tekst('verz_vanaf', { bedrag: geld(VRIJ_VANAF) });

    const cadeauWaarde = (wagen.items || []).filter(isCadeau)
      .reduce((n, i) => n + Math.max(0, (i.original_line_price ?? 0) - (i.final_line_price ?? 0)), 0);
    const korting = Math.max(0, (wagen.total_discount || 0) - cadeauWaarde);
    el('sub-rij').hidden = !korting;
    el('kort-rij').hidden = !korting;
    el('sub').textContent = geld((wagen.original_total_price ?? wagen.items_subtotal_price) - cadeauWaarde);
    el('kort').textContent = '−' + geld(korting);
    el('tot').textContent = geld(tot + kosten);
  }

  function zetBadge() {
    const n = gekocht();
    document.querySelectorAll('.vt-header__cartcount').forEach((b) => b.classList.toggle('visually-hidden', n === 0));
    document.querySelectorAll('[ref="cartBubbleCount"]').forEach((g) => {
      g.textContent = String(n);
      g.classList.toggle('hidden', n === 0);
    });
  }

  function bouw() {
    zetRegels();
    zetSet();
    zetAcc();
    zetStaffel();
    if (cadeauMislukt && !cadeauGemeld) {
      cadeauGemeld = true;
      meld(tekst('cadeau_mislukt'), 'info');
    }
    zetVoet();
    zetBadge();
  }

  let okTeller = null;
  function stopOk() {
    clearTimeout(okTeller);
    okTeller = null;
  }
  function bevestig(zin) {
    const ok = el('ok');
    el('ok-tekst').textContent = zin;
    ok.hidden = false;
    ok.classList.remove('is-weg');
    stopOk();
    okTeller = setTimeout(() => ok.classList.add('is-weg'), 4000);
  }

  function meld(zin, soort) {
    const vak = el('fout');
    vak.classList.toggle('is-info', soort === 'info');
    vak.textContent = zin;
    vak.hidden = false;
    setTimeout(() => { vak.hidden = true; }, 5000);
  }

  let bezig = false;

  async function doe(werk) {
    if (bezig) return;
    bezig = true;
    lade.classList.add('is-bezig');
    try {
      await werk();
      await lees();
    } catch (fout) {
      try { await lees(); } catch {  }
      if (fout?.status === 422) {
        const n = (fout.uitleg || '').match(/\d+/)?.[0];
        meld(n ? tekst('max_n', { n }) : tekst('max'), 'info');
      } else {
        meld(tekst('fout'));
      }
    } finally {
      bouw();
      bezig = false;
      lade.classList.remove('is-bezig');
    }
  }

  const groep = (sleutel) => groepen().find((g) => g.sleutel === sleutel);

  async function ruil(van) {
    const naar = ruilNaar({ variant_id: van });
    if (!naar) return;
    await post(pad('cart/add.js'), { items: [{ id: naar.id, quantity: 1, properties: { _cadeau: 'ja' } }] });
    await haal();
    const items = wagen?.items || [];
    const oud = items.filter((i) => isCadeau(i) && i.variant_id === van).pop();
    const gekocht = items.find((i) => i.variant_id === naar.id && !isCadeau(i));
    const updates = {};
    if (oud) updates[oud.key] = oud.quantity - 1;
    if (gekocht) updates[gekocht.key] = gekocht.quantity - 1;
    if (Object.keys(updates).length) await post(pad('cart/update.js'), { updates });
  }

  document.addEventListener('click', async (e) => {
    const knop = e.target.closest('[data-cart-ruil]');
    if (!knop || lade.contains(knop)) return;
    e.preventDefault();
    knop.disabled = true;
    try {
      await ruil(Number(knop.dataset.cartRuil));
    } finally {
      window.location.reload();
    }
  });

  lade.addEventListener('click', (e) => {
    const knop = e.target.closest('button');
    if (!knop) return;
    const kd = knop.dataset;

    if (kd.ladeWeg) {
      const g = groep(kd.ladeWeg);
      if (!g) return;
      if (isCadeau(g.eerste)) {
        const laatste = g.regels[g.regels.length - 1];
        const s = cadeauStand();
        const nee = Math.min(s.plekken, neeBij() + 1);
        return doe(() => post(pad('cart/update.js'), {
          updates: { [laatste.key]: laatste.quantity - 1 },
          attributes: { _cadeau_nee: String(nee) },
        }));
      }
      const updates = Object.fromEntries(g.regels.map((r) => [r.key, 0]));
      return doe(() => post(pad('cart/update.js'), { updates }));
    }
    if (kd.ladeCadeauTerug !== undefined) {
      cadeauMislukt = false;
      return doe(() => post(pad('cart/update.js'), { attributes: { _cadeau_nee: '' } }));
    }
    if (kd.ladeRuil) {
      const g = groep(kd.ladeRuil);
      if (!g || !ruilNaar(g.eerste)) return;
      return doe(() => ruil(g.eerste.variant_id));
    }
    if (kd.ladeMin || kd.ladePlus) {
      const g = groep(kd.ladeMin || kd.ladePlus);
      if (!g) return;
      const laatste = g.regels[g.regels.length - 1];
      const nieuw = laatste.quantity + (kd.ladeMin ? -1 : 1);
      return doe(() => post(pad('cart/change.js'), { id: laatste.key, quantity: Math.max(0, nieuw) }));
    }
    if (kd.ladeVoeg) {
      const naam = knop.closest('[data-lade-acc]')?.querySelector('a')?.textContent.trim() || '';
      return doe(async () => {
        await post(pad('cart/add.js'), { items: [{ id: Number(kd.ladeVoeg), quantity: 1 }] });
        bevestig(tekst('toegevoegd', { naam }));
      });
    }
    if (kd.ladeStaffelKnop !== undefined && kd.sleutel) {
      const g = groep(kd.sleutel);
      if (!g) return;
      const laatste = g.regels[g.regels.length - 1];
      return doe(() => post(pad('cart/change.js'), { id: laatste.key, quantity: laatste.quantity + Number(kd.aantal || 1) }));
    }
  });

  async function toon(soort, regel) {
    try {
      await lees();
    } catch {
      window.location.href = pad('cart');
      return;
    }
    bouw();
    if (soort === 'toegevoegd' && regel?.product_title) {
      bevestig(tekst('toegevoegd', { naam: regel.product_title }));
    } else {
      el('ok').hidden = true;
      stopOk();
    }
    open();
  }

  document.addEventListener('click', (e) => {
    const wagentje = e.target.closest('.vt-header__cart, [data-vt-cart-open]');
    if (!wagentje || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    toon('wagen');
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]') || form.dataset.geenLade === 'true') return;
    e.preventDefault();
    const knop = form.querySelector('[type="submit"]');
    if (knop) knop.disabled = true;
    try {
      const r = await fetch(pad('cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!r.ok) throw new Error('toevoegen mislukt');
      const uit = await r.json();
      await toon('toegevoegd', uit?.items?.[0] || uit);
    } catch {
      form.dataset.geenLade = 'true';
      form.submit();
    } finally {
      if (knop) knop.disabled = false;
    }
  }, true);

  if (d.cadeauNodig !== undefined) {
    haal()
      .then(cadeauGoed)
      .then((anders) => {
        if (!anders) return;
        if (document.querySelector('.vt-cart-section')) return window.location.reload();
        return haal().then(zetBadge);
      })
      .catch(() => {});
  }

  document.addEventListener('vt:lade', (e) => toon(e.detail?.soort || 'wagen', e.detail?.regel));

  document.addEventListener('cart:refresh', (e) => {
    if (window.location.pathname.includes('/cart')) return;
    if (e.target?.closest?.('[data-lade]') || lade.open) return;
    toon('toegevoegd');
  });

  document.addEventListener('shopify:cart:lines-update', (e) => {
    Promise.resolve(e.promise).then(haal).then(zetBadge).catch(() => {});
  });
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) haal().then(zetBadge).catch(() => {});
  });
})();

(() => {
  const SLEUTEL = { kabel: 'vt-cadeau-kabel', lader: 'vt-cadeau-lader' };
  document.querySelectorAll('[data-vt-cadeau-keuze]').forEach((groep) => {
    const sleutel = SLEUTEL[groep.dataset.vtCadeauKeuze];
    if (!sleutel) return;
    try {
      const eerder = localStorage.getItem(sleutel);
      const optie = eerder && groep.querySelector(`input[value="${CSS.escape(eerder)}"]`);
      if (optie) optie.checked = true;
    } catch {  }
    groep.addEventListener('change', (e) => {
      if (e.target.type !== 'radio') return;
      try { localStorage.setItem(sleutel, e.target.value); } catch {  }
    });
  });
})();
